import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { zeusLogo } from 'src/component/util/image';
import styles from 'src/screen/login-screen/login-screen.module.scss';

export const LoginBanner = (): React.ReactElement => {
	return (
		<Container className={`ms-0 me-0 ${styles.imgBack}`}>
			<Row className="px-lg-1 pt-5 pb-3">
				<Col lg={1}></Col>
				<Col lg={10}>
					<h1>
						<img
							src={zeusLogo}
							className="logo-position"
						/>
					</h1>
				</Col>
				<Col lg={1}></Col>
			</Row>
			<Row className="px-lg-1 py-3">
				<Col lg={1}></Col>
				<Col
					lg={10}
					className="p-0"
				>
					<h1 className="color-secondary pb-3">
						<b className="font-44">Hauliers</b>
					</h1>
					<p className="color-white fs-4">
						<h3 className="font-18">
							Gain instant, free access to domestic UK
							<br /> loads and contract lanes. Use our Drivers <br />
							app to keep everything mobile and <br /> benefit from fast payments.
						</h3>
					</p>
				</Col>
				<Col lg={1}></Col>
			</Row>
			<Row className="px-lg-1 py-3">
				<Col lg={1}></Col>
				<Col
					lg={10}
					className="p-0"
				>
					<p className="color-white fs-4">
						<b className="font-18">
							INCREASE YOUR REVENUES,
							<br />
							STREAMLINE YOUR SUPPLY CHAIN.
						</b>
					</p>
				</Col>
				<Col lg={1}></Col>
			</Row>
		</Container>
	);
};
